module.exports = __webpack_public_path__ + "static/media/Webinar-pana.63478986.png";